import SideNav from "../SideNav/SideNav";
import Fancybox from "../Fancybox/Fancybox";
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import { Image } from "react-bootstrap";

import screenshot1 from '../../assets/img/screenshots/reporting_system/1.jpg';
import screenshot2 from '../../assets/img/screenshots/reporting_system/2.jpg';
import screenshot3 from '../../assets/img/screenshots/reporting_system/3.jpg';

function Reporting() {

    return (
        <div id="wrap-body">
            <div className="heading-group page-name color-w">
                <h1>Clinical System</h1>
                <div className="intro">
                    <p>Additional features include a Weight Tracker-Supplement Usage Manager designed to manage weights and help control supplement costs for our clients. Unnecessary supplements are identified to discontinue based on resident status changes. It provides detailed information valuable to assess needs, manage costs, and eliminate liability. This module also includes integrated supplement/snack labels, supplement/snack production reports, etc. These reports automatically update every time a change is made for the resident which helps assure accuracy and cost effectiveness.</p>
                </div>
                <div className="star-group">
                    <i className="fa fa-star-o"></i>
                    <i className="fa fa-star-o star-1x"></i>
                    <i className="fa fa-star-o"></i>
                </div>
            </div>
            <div class="container" id="main-content">
                <div class="reservation">
                    <div class="title">Reporting System
                        <h3>Highlights</h3>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                        <ul class="custom_list">
                                <li>Supplement Usage Manager is an integrated report that displays all residents, diet orders, supplement orders, ideal/usual body weights, body mass index, current weights, percent changes and alerts. The system red flags residents who are overweight receiving supplements, residents that are underweight without supplements, and residents that have significant weight changes to manage supplement usage. This system will reduce supplement costs to exactly what is required to address the acuity level of your residents as well as help maintain census with healthy residents.</li>
                                <li>The POS Resident Dining Survey is an integrated system that records the resident’s perception of the dining services. Users will have a rating, food temperature score and know foods that residents prefer on the menus. A great tool for managing operations and assuring resident satisfaction.</li>
                                <li>Supplement labels include resident images, product order information and have multiple print options.</li>
                                <li>Diet Master includes names, diet orders, production numbers, and percent intakes.</li>
                                <li>Beverage Master includes totals of all beverages (regular &amp; thickened) that need to be setup prior to each meal service. This production report will eliminate all beverage waste.</li>
                                <li>Supplement Master includes names, supplement orders, delivery times, and supplement par levels to manage inventory and control costs.</li>
                                <li>Snack Master includes names, snack orders, delivery times and preparation data to improve efficiency. </li>
                                <li>Adaptive Device Master includes names, devices, times and tray line set up data.</li>
                                <li>Thicken Liquids Master includes names, thickened liquids, times, etc.</li>
                                <li>Everything in the Clinical System Module is integrated with the tray tickets to automatically reflect changes in each of the above systems.</li>
                            </ul>
                        </div>
                        <div class="col-md-4">
                        <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                    },
                                }}
                            >
                            <a href={screenshot1} data-fancybox="screenshots" data-caption="Supplement Usage Manager" id="lnk_screenshots">See screenshot samples</a>
                            <div style={{display:'none'}}>
                                <a href={screenshot2} data-fancybox="screenshots" data-caption="Supplement Labels">
                                    <Image src={screenshot2}></Image>
                                </a>
                                <a href={screenshot3} data-fancybox="screenshots" data-caption="POS Resident Dining Survey">
                                    <Image src={screenshot3}></Image>
                                </a>
                            </div>
                        </Fancybox>
                        <SideNav/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


}

export default Reporting;